import { hostHas } from '../shared/host-capabilities';
import { CheckCircle2 } from 'lucide-react';
import { ExportLine, Sending } from './HostExportPanel';
import { useTour } from '../renderer/TourCard';
import { readTour } from '../renderer/tour';
import { useTourExport } from './TourDownload';

/**
 * PAIGE: the sample tour's job, whose export line counts the five. An ordinary job with nowhere to send
 * its documents shows "5 ready to send" over Set up export there, which under a tour card saying
 * "All five are exported" reads as if nothing went (first-run walk, 2026-10-06). The tour's five stay
 * in Paige, exported to the job's Download, so its line is CapturePoint's first-export card with the
 * real count: how many of the five have their package, the number the card and the
 * download wait on (`useTourExport`), and never a button that sets anything up on a job the tour
 * removes.
 */
export function useSampleTourJob(jobId: string): boolean {
  const tour = useTour();
  return !hostHas('desktop-export') && tour?.jobId === jobId && !tour.own;
}

/** Whether a workspace job is the sample tour's job right now, asked outside React (the new-job route). */
export function isSampleTourJob(workspaceJobId: string): boolean {
  const tour = readTour();
  return tour?.jobId === workspaceJobId && !tour.own;
}

/** The sample tour's export line: how many of the five have their package, then all of them exported. */
export function useTourExportLine(jobId: string, active: boolean, documents: number) {
  const { ready, exported, total } = useTourExport(jobId, active, documents);
  if (!active) return null;
  const count = exported.toLocaleString('en-US');
  return ready || total === 0 ? (
    <ExportLine icon={<CheckCircle2 size={16} />} tone="done" words={`${count} exported`} />
  ) : (
    <ExportLine
      icon={<Sending />}
      tone="exporting"
      words={`${count} of ${total.toLocaleString('en-US')} exported`}
    />
  );
}
